import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import SplashScreen from "@/components/SplashScreen";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ContactFloating from "@/components/WhatsAppButton";

import Home from "@/pages/Home";
import QuickQuote from "@/pages/QuickQuote";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import BookingWizard from "@/pages/BookingWizard";
import BookingSuccess from "@/pages/BookingSuccess";
import CustomerDashboard from "@/pages/CustomerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import DriverDashboard from "@/pages/DriverDashboard";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import RoutesHub from "@/pages/Routes";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <SplashScreen />
          <div className="min-h-screen flex flex-col bg-background text-foreground">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/quote" element={<QuickQuote />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/book" element={<BookingWizard />} />
                <Route path="/booking/success" element={<BookingSuccess />} />
                <Route path="/dashboard" element={<CustomerDashboard />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/driver" element={<DriverDashboard />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/routes" element={<RoutesHub />} />
              </Routes>
            </main>
            <Footer />
            <ContactFloating />
            <Toaster richColors position="top-right" />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
